import React from 'react'
import { useBrewDetailStore } from '../../state/useBrewDetailStore'
import * as UI from '@brewlogix/blx-ui'
import { snakeToPascal } from 'src/util/helpers'

const HintsOfFlavorNotes: React.FC = () => {
    const { hintsOfFlavorNotes } = useBrewDetailStore()

    const jsxHintsFlavorNotes = hintsOfFlavorNotes?.length
        ? hintsOfFlavorNotes?.map((item) => (
              <UI.Pill
                  key={item}
                  label={snakeToPascal(item.toString())}
                  customClasses='bg-gray-100 text-base py-1 px-3 text-gray-500'
              />
          ))
        : null
    return (
        jsxHintsFlavorNotes && (
            <div className='col-span-2 flex flex-col gap-2 sm:col-span-1'>
                <span className='text-base font-bold text-gray-300'>“Hints of” Flavor Notes</span>
                <div className='flex flex-wrap gap-1'>{jsxHintsFlavorNotes}</div>
            </div>
        )
    )
}

export default HintsOfFlavorNotes
